module.exports = __webpack_public_path__ + "static/media/sprite.5b3b1b34.svg";